export function getEditFormConfig() {
	return {
		DWRG: [
			{
				el: "el-input",
				label: "名称",
				name: "name",
				attrs: {
					placeholder: "请输入名称",
				},
			},
			{
				el: "el-input",
				label: "标题",
				name: "title",
				attrs: {
					keyWord: "title",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "维度解析",
				name: "descr",
				attrs: {
					keyWord: "descr",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "专家总结",
				name: "content",
				attrs: {
					keyWord: "content",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
		],
		DWRG_WD: [
			{
				el: "el-input",
				label: "等级",
				name: "title",
				attrs: {
					clearable: true,
					placeholder: "请输入等级",
				},
			},
			{
				el: "rich-text",
				label: "心理图谱概览",
				name: "descr",
				attrs: {
					keyWord: "descr",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "维度优势",
				name: "advantageDesc",
				attrs: {
					keyWord: "advantageDesc",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "维度劣势",
				name: "weaknessDesc",
				attrs: {
					keyWord: "weaknessDesc",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "el-input",
				label: "个性标签",
				name: "keyword",
				attrs: {
					keyWord: "keyword",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "标签解读",
				name: "keywordDesc",
				attrs: {
					keyWord: "keywordDesc",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "维度详解",
				name: "content",
				attrs: {
					keyWord: "content",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "发展建议",
				name: "suggest",
				attrs: {
					keyWord: "suggest",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
		],
		DEFAULT: [
			{
				el: "el-input",
				label: "等级",
				name: "title",
				attrs: {
					clearable: true,
					placeholder: "请输入等级",
				},
			},
			{
				el: "rich-text",
				label: "心理图谱概览",
				name: "descr",
				attrs: {
					keyWord: "descr",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "维度优势",
				name: "advantageDesc",
				attrs: {
					keyWord: "advantageDesc",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "维度劣势",
				name: "weaknessDesc",
				attrs: {
					keyWord: "weaknessDesc",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "el-input",
				label: "关键词",
				name: "keyword",
				attrs: {
					keyWord: "keyword",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "关键词解读",
				name: "keywordDesc",
				attrs: {
					keyWord: "keywordDesc",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "维度详解",
				name: "content",
				attrs: {
					keyWord: "content",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "发展建议",
				name: "suggest",
				attrs: {
					keyWord: "suggest",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
		]

	};
}

export function getColumnConfig() {
	return {
		DWRG: [
			{
				el: "el-table-column",
				label: "名称",
				name: "name",
				attrs: {
					width: "140",
					align: "center",
				},
			},
			{
				el: "el-table-column",
				label: "标题",
				name: "title",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "维度解析",
				name: "descr",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "专家总结",
				name: "content",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
		],
		DWRG_WD: [
			{
				el: "el-table-column",
				label: "等级",
				name: "title",
				attrs: {
					width: "140",
					align: "center",
				},
			},
			{
				el: "el-table-column",
				label: "心理图谱概览",
				name: "descr",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "维度优势",
				name: "advantageDesc",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "维度劣势",
				name: "weaknessDesc",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "个性标签",
				name: "keyword",
				attrs: {
					width: "140",
					align: "center",
				},
			},
			{
				el: "el-table-column",
				label: "标签解读",
				name: "keywordDesc",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "维度详解",
				name: "content",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "发展建议",
				name: "suggest",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
		],
		DEFAULT: [
			{
				el: "el-input",
				label: "等级",
				name: "title",
				attrs: {
					clearable: true,
					placeholder: "请输入等级",
				},
			},
			{
				el: "el-table-column",
				label: "心理图谱概览",
				name: "descr",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "维度优势",
				name: "advantageDesc",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "维度劣势",
				name: "weaknessDesc",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "关键词",
				name: "keyword",
				attrs: {
					width: "140",
					align: "center",
				},
			},
			{
				el: "el-table-column",
				label: "关键词解读",
				name: "keywordDesc",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "维度详解",
				name: "content",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "发展建议",
				name: "suggest",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
		],
	};
}
